"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInitialLoad = void 0;
const isInitialLoad = (queries) => queries.some((query) => query.isLoading && (!query.isError || !query.data));
exports.isInitialLoad = isInitialLoad;
